import React from 'react';

interface ActivityStatusBadgeProps {
    status: string;
    size?: 'sm' | 'md';
}

const toneMap: Record<string, string> = {
    draft: 'bg-slate-100 text-slate-700 ring-slate-200',
    pending_sync: 'bg-yellow-50 text-yellow-800 ring-yellow-200',
    assigned: 'bg-blue-50 text-blue-700 ring-blue-200',
    accepted: 'bg-indigo-50 text-indigo-700 ring-indigo-200',
    in_progress: 'bg-cyan-50 text-cyan-800 ring-cyan-200',
    submitted: 'bg-amber-50 text-amber-800 ring-amber-200',
    awaiting_review: 'bg-amber-50 text-amber-800 ring-amber-200',
    correction_required: 'bg-orange-50 text-orange-800 ring-orange-200',
    resubmitted: 'bg-violet-50 text-violet-800 ring-violet-200',
    approved: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    rejected: 'bg-red-50 text-red-800 ring-red-200',
    cancelled: 'bg-gray-100 text-gray-600 ring-gray-200',
    closed: 'bg-slate-200 text-slate-700 ring-slate-300',
};

export const formatStatus = (status: string): string =>
    String(status || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const ActivityStatusBadge: React.FC<ActivityStatusBadgeProps> = ({ status, size = 'md' }) => {
    const tone = toneMap[String(status || '').toLowerCase()] || 'bg-slate-100 text-slate-700 ring-slate-200';
    const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
    return (
        <span className={`inline-flex items-center whitespace-nowrap rounded-full font-bold ring-1 ring-inset ${tone} ${sizeClasses}`}>
            {formatStatus(status)}
        </span>
    );
};

export default ActivityStatusBadge;
